export enum IApplicationState {
  preDevelopment = 'preDevelopment',
  development = 'development',
  postDevelopment = 'postDevelopment',
}
